import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon';

interface EyebrowProps {
  icon?: IconName;
  children: ReactNode;
  className?: string;
}

/**
 * Small uppercase pill badge used to label sections and product scenes.
 */
export function Eyebrow({ icon, children, className = '' }: EyebrowProps) {
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border border-glass-border bg-white/5 px-3 py-1 ${className}`}
    >
      {icon && <Icon name={icon} size={14} className="text-primary-container" />}
      <span className="font-display text-[0.7rem] font-bold uppercase tracking-[0.18em] text-on-surface-variant">
        {children}
      </span>
    </span>
  );
}
